import React from 'react'
import { DialogContent, makeStyles } from '@material-ui/core'

const useStyle = makeStyles((theme) => ({
  root: {
    padding: '32px 16px 32px',
    ...theme.gofind.scrollBar,
    '&:first-child': { paddingTop: 32 }
  }
}))

export default function MuiDialogContent({ children, isMobile }) {
  const classes = useStyle({ isMobile })
  return <DialogContent className={classes.root}>{children}</DialogContent>
}
